export default __webpack_public_path__ + "static/media/dashboard.e3e43a7e.svg";